import {FC} from 'react'
import {CreditOverview, SubClient} from '../../../../../services/cellcast.v2.types'
import NodataYet from '../../../../Components/NodataYet'
import Billing from './Billing'
import BillingShareCredit from './BillingShareCredit'

export type BillingWrapperProps = {
  reload: () => void
  isFetching: boolean
  credit: CreditOverview
  data: SubClient | undefined
}

const BillingWrapper: FC<BillingWrapperProps> = (props) => {
  const {data} = props
  return (
    <>
      {data ? (
        <>
          {data._id.toString() !== data.ownerId.toString() ? (
            <BillingShareCredit {...props} />
          ) : (
            <Billing {...props} />
          )}
        </>
      ) : (
        <NodataYet />
      )}
    </>
  )
}

export default BillingWrapper
